/**
 * Copy that names the pay-over-time providers a salon offers in the widget
 * (P5.3). Be You's "Pay over time" bar used to say "Cherry" — its earlier
 * link-out financing — and now names the methods its checkout offers.
 */
const FINANCING_NAMES: Record<string, string> = {
  klarna: 'Klarna',
  affirm: 'Affirm',
  afterpay_clearpay: 'Afterpay',
};

/** The providers the Be You "Pay over time" bar names. */
export function payOverTimeProviders(methods: string[] | undefined): string {
  const names = (methods ?? []).map((m) => FINANCING_NAMES[m]).filter(Boolean);
  return names.length > 0 ? names.join(' · ') : 'Cherry';
}
